import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M96.93 62.8c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#D8FFFF"
      d="M84.88 16.26a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M19.48 72.2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="m18.1 89.09 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM106.07 33.14h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M31.12 92.83V23.68c0-.61.67-.97 1.18-.64l7.33 4.81c.27.18.62.17.88-.03l7.72-5.76c.26-.2.62-.2.89-.02l8.64 5.98c.26.18.61.18.87 0l8.55-5.97c.28-.19.65-.18.91.03l7.39 5.89c.26.21.63.22.9.03l7.31-4.95a.763.763 0 0 1 1.19.63v69.04c0 .62-.7.98-1.21.62l-6.94-4.98a.75.75 0 0 0-.88 0l-8.09 5.56c-.26.18-.6.18-.86 0l-8.28-5.58a.77.77 0 0 0-.86 0l-8.13 5.58c-.25.17-.58.18-.84.02l-8.31-5.26a.76.76 0 0 0-.82 0l-7.37 4.76a.765.765 0 0 1-1.18-.64z"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      d="M70.13 48.84H46.05c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h24.08c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M70.13 60.82H46.05c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h24.08c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M70.13 72.79H46.05c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h24.08c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
  </svg>
);
const SvgEnrichedIconReceiptsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconReceiptsBrand);
export default Memo;
